import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TopToolbar,
  CreateButton,
  EditButton,
  DeleteButton,
} from 'react-admin';

const QuizListActions = () => {
  return (
    <TopToolbar>
        <CreateButton
          basePath="/quizzes"
          variant="contained"
          label="New Question"
        />
    </TopToolbar>
  );
};

const QuizList = (props) => {
  return (
    <List
      {...props}
      actions={<QuizListActions />}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" label="Nome" />
        <TextField source='question_point' label='Pontuação'/>
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
}

export default QuizList;